<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rb35NP/tc-custom/9781439677230.jpg?1737364827770" alt="This image is the cover for the book Super Parks! Yosemite National Park, Super Cities"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Super Parks! Yosemite National Park, Super Cities
      </h1>
      <p class="bookDescription body article font2">
        <p>Sometimes the coolest places are right outside your front door. Learning about Yosemite's interesting and unique culture has never been so super fun!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Buckley Jr.
      </h2>
      
      <p class="authorDescription body article">Buckley is the author of more than 200 nonfiction books for kids, including 14 titles in the New York Times-bestselling Who Was…? biography series. He has written for Scholastic, DK Publishing, National Geographic Kids, Discovery Books, and many others. He is also the author of nine books in the Show Me History! graphic nonfiction series. He lives in Santa Barbara, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Children’s Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?282034be